import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0A0A0F] border-t border-white/5 py-32" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="space-y-6">
            <div className="text-3xl font-bold tracking-tight">
              <span className="text-[#D4AF37]">NEHPETS</span>
              <span className="text-white">+</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Premium Event Consultancy & Delivery
            </p>
            <p className="text-white/40 text-xs">
              Trusted by corporate leaders, government agencies, and distinguished private clients since 2007.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Quick Links</h4>
            <div className="space-y-3">
              <Link to="/" className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                Home
              </Link>
              <Link to="/services" className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                Services
              </Link>
              <Link to="/gallery" className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                Portfolio
              </Link>
              <Link to="/about" className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                About Us
              </Link>
              <Link to="/contact" className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                Contact
              </Link>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Our Expertise</h4>
            <div className="space-y-3">
              <p className="text-white/60 text-sm">Strategic Consultancy</p>
              <p className="text-white/60 text-sm">Event Management</p>
              <p className="text-white/60 text-sm">Creative Direction</p>
              <p className="text-white/60 text-sm">VIP & Protocol Services</p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-6 uppercase tracking-wider text-sm">Get In Touch</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="text-[#D4AF37] mt-1" size={16} />
                <a href="mailto:nehpetsplusconcepts@gmail.com" className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                  nehpetsplusconcepts@gmail.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="text-[#D4AF37] mt-1" size={16} />
                <a href="tel:+2348033260400" className="text-white/60 hover:text-[#D4AF37] transition-colors text-sm">
                  +234 803 326 0400
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar with Legal Links */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/40 text-xs">
              © {new Date().getFullYear()} Nehpets+ Concepts. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/legal/privacy" className="text-white/40 hover:text-[#D4AF37] text-xs transition-colors">
                Privacy Policy
              </Link>
              <Link to="/legal/terms" className="text-white/40 hover:text-[#D4AF37] text-xs transition-colors">
                Terms of Service
              </Link>
              <Link to="/legal/cookies" className="text-white/40 hover:text-[#D4AF37] text-xs transition-colors">
                Cookie Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;